// Voice of Nigeria Residence — current featured development.
// Copy in `overviewHeading` / `fullDescription` is factual and conservative;
// swap for the Sales Team's approved marketing copy when supplied.
const voiceOfNigeriaResidence = {
  id: 'voice-of-nigeria-residence',
  slug: 'voice-of-nigeria-residence',
  name: 'Voice of Nigeria Residence',
  category: 'Residential Development',

  status: 'now-selling',
  featured: true,
  listed: true,

  location: {
    area: 'Onikoyi, Ikoyi',
    city: 'Lagos',
    display: 'Onikoyi, Ikoyi, Lagos',
    mapEmbedUrl: null,
    nearby: [],
  },

  shortDescription:
    'Premium 2, 3 & 4 bedroom apartments and maisonettes in Onikoyi, Ikoyi — a 20-unit residential development by Winchester Construction and NimbleCasa, now selling.',
  overviewHeading: 'A premium residential development in Ikoyi',
  fullDescription: [
    'Voice of Nigeria Residence is a 20-unit residential development in Onikoyi, one of Ikoyi’s most established neighbourhoods. The building offers two and three bedroom apartments alongside three and four bedroom maisonettes, designed for owner-occupiers and investors seeking a well-located Lagos address.',
    'Every residence is finished to a high standard and served by lift access to all floors, with ground-floor parking, a swimming pool, an on-site gym and 24-hour power. The development is delivered by Winchester Construction and NimbleCasa.',
  ],

  // short marketing line shown on the homepage preview card
  keyFeatures: ['Swimming Pool', 'On-site Gym', '24-Hour Power', 'Lift Access'],
  quickFacts: [
    { label: 'Total Units', value: '20' },
    { label: 'Bedrooms', value: '2 – 4' },
    { label: 'Location', value: 'Onikoyi, Ikoyi' },
    { label: 'Status', value: 'Now Selling' },
  ],

  unitCountLabel: '20 Units',
  unitMix: [
    { type: '2 Bedroom Apartment', count: 14 },
    { type: '3 Bedroom Apartment', count: 7 },
    { type: '3 Bedroom Maisonette', count: 2 },
    { type: '4 Bedroom Maisonette', count: 1 },
  ],
  unitTypes: [
    { type: '2 Bedroom Apartment', bedrooms: 2 },
    { type: '3 Bedroom Apartment', bedrooms: 3 },
    { type: '3 Bedroom Maisonette', bedrooms: 3 },
    { type: '4 Bedroom Maisonette', bedrooms: 4 },
  ],

  amenities: [
    { icon: '⚡', name: '24-Hour Power Supply' },
    { icon: '🍳', name: 'Modern Fitted Kitchen' },
    { icon: '🅿️', name: 'Ground Floor Parking' },
    { icon: '🛗', name: 'Lift Access' },
    { icon: '📷', name: 'CCTV Security' },
    { icon: '🏋️', name: 'On-site Gym' },
    { icon: '🏊', name: 'Swimming Pool' },
    { icon: '🛋️', name: 'Spacious Living Areas' },
    { icon: '🔧', name: 'Facility Management' },
  ],

  parking: {
    show: true,
    heading: 'Ground Floor Parking',
    body: 'The ground floor of the development is given over to resident parking, keeping vehicles secure and off the street while the residential floors above stay quiet.',
    image: null,
  },
  lift: {
    show: true,
    note: 'Lift access to all residential floors.',
  },

  // The project uses its promotional flyer as its single image — shown as-is,
  // uncropped (object-fit: contain), everywhere the project image appears.
  imageMode: 'flyer',
  hero: {
    src: '/project-media/voice-of-nigeria-residence/flyer-1400.jpg',
    srcWebp: '/project-media/voice-of-nigeria-residence/flyer.webp',
    srcSmall: '/project-media/voice-of-nigeria-residence/flyer-1024.jpg',
    alt: 'Voice of Nigeria Residence project flyer',
    width: 1536,
    height: 1024,
  },
  cardImage: {
    src: '/project-media/voice-of-nigeria-residence/flyer-1024.jpg',
    alt: 'Voice of Nigeria Residence project flyer',
    width: 1024,
    height: 683,
  },
  gallery: [],
  floorPlans: [],
  brochure: {
    label: 'Project Flyer',
    thumb: '/project-media/voice-of-nigeria-residence/flyer-1024.jpg',
    file: '/project-media/voice-of-nigeria-residence/flyer.jpg',
  },

  partners: [
    { role: 'Developed By', name: 'Winchester Construction', logo: null },
    { role: 'Developed By', name: 'NimbleCasa', logo: null },
  ],

  enquiry: {
    phone: '09168584819',
    whatsappHref: null,
    prefillInterest: 'Voice of Nigeria Residence',
  },

  seo: {
    title: 'Voice of Nigeria Residence | Premium Apartments in Ikoyi | NimbleCasa',
    description:
      'Voice of Nigeria Residence — premium 2, 3 & 4 bedroom apartments and maisonettes in Onikoyi, Ikoyi, Lagos. A 20-unit development by Winchester Construction, now selling through NimbleCasa.',
    ogImage: '/project-media/voice-of-nigeria-residence/flyer.jpg',
  },
};

export default voiceOfNigeriaResidence;
